/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export function DropdownMenu2() {
    return <>
        {/*begin::Navigation*/}
        <ul className="navi navi-hover">
            {/* <li className="navi-header pb-1">
                <span className="text-primary text-uppercase font-weight-bold font-size-sm">Add new:</span>
            </li> */}
            <li className="navi-item">
                <a href="#" className="navi-link">
                    <span className="navi-icon"><i className="flaticon2-calendar-8"></i></span>
                    <span className="navi-text">January</span>
                </a>
            </li>
            <li className="navi-item">
                <a href="#" className="navi-link">
                    <span className="navi-icon"><i className="flaticon2-calendar-8"></i></span>
                    <span className="navi-text">February</span>
                </a>
            </li>
            <li className="navi-item">
                <a href="#" className="navi-link">
                    <span className="navi-icon"><i className="flaticon2-calendar-8"></i></span>
                    <span className="navi-text">March </span>
                </a>
            </li>
            <li className="navi-item">
                <a href="#" className="navi-link">
                    <span className="navi-icon"><i className="flaticon2-calendar-8"></i></span>
                    <span className="navi-text">April</span>
                </a>
            </li>
            <li className="navi-item">
                <a href="#" className="navi-link">
                    <span className="navi-icon"><i className="flaticon2-calendar-8"></i></span>
                    <span className="navi-text">May</span>
                </a>
            </li>
        </ul>
        {/*end::Navigation*/}
    </>
}
